// src/App.jsx
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AdminProvider }         from "./context/AdminContext";
import { SidebarProvider }       from "./context/SidebarContext";
import AppRouter                 from "./routes/AppRouter";
import Sidebar                   from "./components/Sidebar/Sidebar";
import LinkAccountModal          from "./components/AuthPanel/LinkAccountModal";

// ─── Engel Ekranı ─────────────────────────────────────────────────────────────
// Kullanıcı banlıysa tüm site içeriği yerine bu ekran gösterilir.
function BlockedScreen() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "#0d0a05",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'Courier Prime', monospace",
    }}>
      <style>{`
        @keyframes bc-fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .bc-blocked-card {
          animation: bc-fadeUp 0.5s ease both;
        }
      `}</style>

      <div className="bc-blocked-card" style={{
        textAlign: "center",
        maxWidth: 440,
        padding: "48px 32px",
        border: "1px solid rgba(212,168,83,0.12)",
        background: "#12100a",
      }}>

        {/* İkon */}
        <div style={{
          fontSize: 40,
          marginBottom: 24,
          lineHeight: 1,
        }}>🚫</div>

        {/* Ayraç üst */}
        <div style={{
          height: 1,
          background: "linear-gradient(90deg,transparent,rgba(212,168,83,0.2),transparent)",
          marginBottom: 24,
        }} />

        {/* Başlık */}
        <h1 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 18,
          fontWeight: 700,
          color: "rgba(212,168,83,0.7)",
          letterSpacing: "0.08em",
          marginBottom: 16,
        }}>
          Hesabınız Engellendi
        </h1>

        {/* Mesaj */}
        <p style={{
          fontSize: 11,
          color: "rgba(232,213,176,0.4)",
          letterSpacing: "0.1em",
          lineHeight: 1.9,
          marginBottom: 28,
        }}>
          Topluluk kurallarını ihlal ettiğiniz için<br />
          artık bir şey yayınlayamaz veya göremezsiniz.
        </p>

        {/* Ayraç alt */}
        <div style={{
          height: 1,
          background: "linear-gradient(90deg,transparent,rgba(212,168,83,0.12),transparent)",
          marginBottom: 24,
        }} />

        {/* İletişim notu */}
        <p style={{
          fontSize: 9,
          color: "rgba(212,168,83,0.25)",
          letterSpacing: "0.18em",
          textTransform: "uppercase",
        }}>
          Hata olduğunu düşünüyorsanız destekle iletişime geçin.
        </p>
      </div>
    </div>
  );
}

// ─── Uygulama İçeriği ─────────────────────────────────────────────────────────
// AuthProvider içinde olduğu için useAuth kullanılabilir.
function AppContent() {
  const { isBlocked, linkRequired } = useAuth();

  if (isBlocked) return <BlockedScreen />;

  return (
    <AdminProvider>
      <SidebarProvider>
        {/* Google + email hesap bağlama modalı */}
        {linkRequired && <LinkAccountModal />}
        <Sidebar />
        <AppRouter />
      </SidebarProvider>
    </AdminProvider>
  );
}

// ─── Kök Bileşen ──────────────────────────────────────────────────────────────
export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}
